export default __webpack_public_path__ + "27782ec1b80dad71588c600f93319aba.svg";